import { PartnersApi } from '@deckee/api-app-main';
import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { AppAsyncThunkAPI } from '../..';
import apiConfiguration from '../../../backend/apiConfiguration';
import { Partner } from './partners.models';

const partnerApi = new PartnersApi(apiConfiguration);

export const resetPartners = createAction('[partner] reset');

export const addPartner = createAction('[partner] add', (partner: Partner) => ({
  payload: partner,
}));

export const setPartners = createAction(
  '[partner] set a list of partners',
  (partners: Partner[]) => ({
    payload: partners,
  }),
);

export const fetchPartner = createAsyncThunk<
  void,
  { slug: string },
  AppAsyncThunkAPI
>('fetch partner details', async ({ slug }, { dispatch, rejectWithValue }) => {
  try {
    const partnerResponse = await partnerApi.getPartner({
      slug,
    });

    dispatch(addPartner(partnerResponse.data));
  } catch (e: any) {
    rejectWithValue(`Error loading partner details for slug ${slug}`);
  }
});

export const fetchPartners = createAsyncThunk<void, void, AppAsyncThunkAPI>(
  'fetch partners for bounding box',
  async (_, { dispatch, rejectWithValue, getState, signal }) => {
    try {
      signal.throwIfAborted();
      const [topLeft, bottomRight] =
        getState().appControls.currentMapParams.viewPortDetails.bounds;

      const partnerResponse = await partnerApi.getPartners(
        {
          bottomRightLatitude: bottomRight.lat,
          bottomRightLongitude: bottomRight.lon,
          topLeftLatitude: topLeft.lat,
          topLeftLongitude: topLeft.lon,
        },
        {
          signal,
        },
      );

      dispatch(setPartners(partnerResponse.data));
    } catch (e) {
      rejectWithValue(undefined);
    }
  },
);
